import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

export interface FifBranch {
  id: number;
  dprn: string;
  name: string;
  address: string;
}

export interface FifBranchListResponse {
  results: FifBranch[];
  rowCount: number;
  currentPage: number;
  pageSize: number;
  pageCount: number;
}

export type FifBranchPayload = Pick<FifBranch, 'dprn' | 'name' | 'address'>;

@Injectable({
  providedIn: 'root',
})
export class FifBranchService {
  private readonly uri: string = `${environment.DO_URL}/v2/fif-branches`;

  constructor(private readonly http: HttpClient) {}

  list(page: number, pageSize: number, search = ''): Observable<FifBranchListResponse> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (search.trim()) {
      params = params.set('search', search.trim());
    }
    return this.http.get<FifBranchListResponse>(this.uri, { params });
  }

  create(payload: FifBranchPayload): Observable<{ data: FifBranch }> {
    return this.http.post<{ data: FifBranch }>(this.uri, payload);
  }

  update(id: number, payload: FifBranchPayload): Observable<{ data: FifBranch }> {
    return this.http.put<{ data: FifBranch }>(`${this.uri}/${id}`, payload);
  }

  delete(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.uri}/${id}`);
  }
}